import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import { validaSoloNumero } from "../../util/varios";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";

const ImprimirConsiliaciones = (props) => {
  const token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const [mostrar, setMostrar] = useState(false)
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuentabancaria: "",
    nombre: "",
    cuentabancaria: "",
    sucursal: "",
    direccion: "",
    contacto: "",
    telefono: "",
    presupuesto: "",
    saldoconcil: "",
    saldolib: "",
    codctacont: "",
    tipo: "",
    concepto: "",
    debitobanc: "",
    porcentdebito: "",
    codctadebitobanc: "",
    idorganizacion: "",
    idefiscal: "",
    idbanco: "",
    caduca: "",
    idcuentacontable: "",
    depositoweb: "",
    activo: "",
  });

  // Referencias para los inputs
  const txtIdCuenta = useRef(null);
  const txtNomBanco = useRef(null);
  const txtNumCuenta = useRef(null);
  const cmbMes = useRef(null);
  const cmbAnio = useRef(null);

  // Generar años desde 2024 hasta el actual
  const generarAnios = () => {
    const anioActual = new Date().getFullYear();
    const anioIni = anioActual - 2;
    const anios = [];
    for (let i = anioActual; i >= anioIni; i--) {
      anios.push(i);
    }
    return anios;
  };

  const meses = [
    { nombre: "Enero", valor: 1 },
    { nombre: "Febrero", valor: 2 },
    { nombre: "Marzo", valor: 3 },
    { nombre: "Abril", valor: 4 },
    { nombre: "Mayo", valor: 5 },
    { nombre: "Junio", valor: 6 },
    { nombre: "Julio", valor: 7 },
    { nombre: "Agosto", valor: 8 },
    { nombre: "Septiembre", valor: 9 },
    { nombre: "Octubre", valor: 10 },
    { nombre: "Noviembre", valor: 11 },
    { nombre: "Diciembre", valor: 12 },
  ];

  console.log(props);

  const imprimir = async () => {

    let reporte = "";
    let condi = '';
    let tipo = 0;

    // Obtener valores de las referencias
    const codigo = txtIdCuenta.current.value;
    const banco = txtNomBanco.current.value;
    const cuenta = txtNumCuenta.current.value;
    const mes = cmbMes.current.value;
    const anio = cmbAnio.current.value;

    console.log({ codigo, banco, cuenta, mes, anio }); // Para depuración

    // Validaciones básicas
    if (!cuenta) {
      //alert("Por favor complete los campos: Mes, Año y Cuenta");
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "¡ Por favor complete el campo Cuenta !",
        icono: "informacion",
      });
      txtIdCuenta.current.focus();
      return;
    } else if (!mes) {
      //alert("Por favor complete los campos: Mes, Año y Cuenta");
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "¡ Por favor complete el campo Mes !",
        icono: "informacion",
      });
      cmbMes.current.focus();
      return;
    } else if (!anio) {
      //alert("Por favor complete los campos: Mes, Año y Cuenta");
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "¡ Por favor complete el campo Año !",
        icono: "informacion",
      });
      cmbAnio.current.focus();
      return;
    }


    // Convertir valores a números
    const mesNum = parseInt(mes, 10);
    const anioNum = parseInt(anio, 10);
    const cuentaNum = parseInt(cuenta, 10);

    // Validar conversiones
    if (isNaN(mesNum) || isNaN(anioNum) || isNaN(cuentaNum)) {
      //alert("Mes, Año y Cuenta deben ser valores numéricos");
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "¡ Mes, Año y Cuenta deben ser valores numéricos !",
        icono: "informacion",
      });
      return;
    }

    // Calcular días del mes
    const ultimoDia = new Date(anioNum, mesNum, 0).getDate();

    // Formatear fechas (dd-MM-yyyy)
    const val2 = `01-${String(mesNum).padStart(2, '0')}-${anioNum}`;
    const val3 = `${String(ultimoDia).padStart(2, '0')}-${String(mesNum).padStart(2, '0')}-${anioNum}`;

    // Construir condición SQL según tipo de reporte
    if (props.report === 'Movimientos Conciliados') {
      reporte = "Tes_Conciliac";
      condi = `MOV_FchConcil Between '${val2}' AND '${val3}' AND mov.mov_idctabco = ${codigo}`;
    }
    else if (props.report === 'Movimientos por Conciliar') {

      reporte = "Tes_Conciliar";
      condi = `MOV_FchConcil Between '${val2}' AND '${val3}' AND DOC.DOC_IdCtaB = ${codigo}`;
    }
    else if (props.report === 'Conciliaciones') {
      reporte = "Tes_Conciliacion";
      condi = `MOV_FchConcil Between '${val2}' AND '${val3}' AND mov.mov_idctabco = ${codigo}`;

    }


    const url = new URL(`${op.reportes}/administracionTesoreria`);
    url.searchParams.append('reporte', reporte);
    url.searchParams.append('condicion', condi);
    url.searchParams.append('tipo', tipo);
    url.searchParams.append('desde', "'" + val2 + "'");
    url.searchParams.append('hasta', "'" + val3 + "'");
    url.searchParams.append('IDCTA', codigo);
    url.searchParams.append('TIT_CRI1', `${mesNum}/${anioNum}`);

    // Abrir ventana con el reporte
    window.open(
      url.toString(),
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );


   

  };

  const cancelar = () => {
    blanquear();
    setValues({
      idcuentabancaria: "",
      nombre: "",
      cuentabancaria: "",
      sucursal: "",
      direccion: "",
      contacto: "",
      telefono: "",
      presupuesto: "",
      saldoconcil: "",
      saldolib: "",
      codctacont: "",
      tipo: "",
      concepto: "",
      debitobanc: "",
      porcentdebito: "",
      codctadebitobanc: "",
      idorganizacion: "",
      idefiscal: "",
      idbanco: "",
      caduca: "",
      idcuentacontable: "",
      depositoweb: "",
      activo: "",
    })
    props.onHideCancela();
  };

  const blanquear = () => {
    setActivate(false);
    // Limpiar valores de los inputs
    if (txtIdCuenta.current) txtIdCuenta.current.value = '';
    if (txtNomBanco.current) txtNomBanco.current.value = '';
    if (txtNumCuenta.current) txtNumCuenta.current.value = '';
    if (cmbMes.current) cmbMes.current.value = '';
    if (cmbAnio.current) cmbAnio.current.value = '';
  };


  const onCatalogoCuenta = (values) => {
    setMostrar(false);

    setValues(values);
    txtIdCuenta.current.value = values.idcuentabancaria;
  };

  const handleCuentaBancaria = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {
        seleccionarCuentaBancaria(event.target.value);
      }
    }
  };
  const seleccionarCuentaBancaria = (codigo) => {
    let campos = "*"
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`
    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'

      },
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data.idcuentabancaria > 0) {
          txtIdCuenta.current.value = response.data.idcuentabancaria;
          txtNomBanco.current.value = response.data.nombre;
          txtNumCuenta.current.value = response.data.cuentabancaria;
          cmbMes.current.focus();
        } else {
          setMensaje({ mostrar: true, titulo: 'Error.', texto: '¡Código i/o Cuenta Bancaria, No esta Registrado!', icono: 'error' });
          txtIdCuenta.current.value = '';
          txtNomBanco.current.value = '';
          txtNumCuenta.current.value = '';
          txtIdCuenta.current.focus();
        }
      }
    }).catch((error) => {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    })
  }
  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    txtNomBanco.current.value = '';
    txtNumCuenta.current.value = '';
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.which === 13) {
        if (event.target.id === 'idcuenta') {
          cmbMes.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold" style={{ color: "#fff" }}>
          <h3>{props.report}</h3>
        </div>

        <a href="#" onClick={cancelar} className="text-light">
          <i className="fas fa-times fa-1x shadow"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <Dimmer active={activate} />

        <CatalogoCuentaBancaria
          show={mostrar}
          onHideCancelar={() => {
            setMostrar(false);
          }}
          onHideAceptaCatalogo={onCatalogoCuenta}
        />


        <div className="col-md-12 row mx-auto px-0">
          <div class="input-group input-group-sm mb-1 col-md-3">
            <span class="input-group-text" id="inputGroup-sizing-sm">Código:</span>
            <input
              type="text"
              //disabled

              class="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={handleInputNumChange}
              onKeyUp={handleCuentaBancaria}
              onBlur={handleCuentaBancaria}
              ref={txtIdCuenta}
            />
            <button type="button"
              onClick={() => setMostrar(true)} class="btn btn-success">
              <i class="fas fa-search"></i>
            </button>
          </div>
          <div className="col-9"></div>

          <div class="input-group input-group-sm mb-1 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">Banco:</span>
            <input
              value={values ? values.nombre : ''}
              disabled
              type="text"
              class="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              ref={txtNomBanco}
            />
          </div>

          <div class="input-group input-group-sm mb-1 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">N° Cuenta:</span>
            <input
              value={values ? values.cuentabancaria : ''}

              disabled
              type="text"
              class="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              ref={txtNumCuenta}
            />
          </div>

          {/* Selectores de Mes y Año */}
          <div class="input-group input-group-sm mb-1 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">Mes:</span>
            <select
              class="form-select"
              ref={cmbMes}
            >
              {meses.map((mes) => (
                <option key={mes.valor} value={mes.valor}>
                  {mes.nombre}
                </option>
              ))}
            </select>
          </div>

          <div class="input-group input-group-sm mb-1 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">Año:</span>
            <select
              class="form-select"
              ref={cmbAnio}
            >
              {generarAnios().map((anio) => (
                <option key={anio} value={anio}>
                  {anio}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto d-flex justify-content-end">
          <div className="col-md-12 d-flex justify-content-end ml-auto px-0 m-0">
            <button
              onClick={imprimir}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print"> Imprimir</i>
            </button>
            <button
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ImprimirConsiliaciones;